import { render, staticRenderFns } from "./releaseDemandDebt.vue?vue&type=template&id=dcaac410&scoped=true&"
import script from "./releaseDemandDebt.vue?vue&type=script&lang=js&"
export * from "./releaseDemandDebt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcaac410",
  null
  
)

export default component.exports